var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.205078,
    y: 0.704987,
    width: 27.59,
    height: 27.59,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10755_43083",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10755_43083",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACiUlEQVR4nO3dzWoTURTA8au40U2tuSdYqBvRpa50KyLuXRTRJxDa3Bs/XiDFlxGjINScmyBCcS0+RVeCYkRX2UQmS7FCkmnPyeT/g7OfOf+Z5qtpQwAAAAAAAAAALzZ3R1ck674kfSVZ+42aNDun/Uu5bIdV0O6Wm5J1LLlMGz2p/Gh39EbwLib9aL6sfDoTc/kQvItJf69PEP0VvLNekpzyBO+sFyQEIYhr1lescIcQxDXrK1a4Q/4KkoYP12kCAAAAGqPXOxu75XHMOopZv1o/95cVmWpXMZVhTPoohOmZWlpczkUklU/WJycrP3q49eIgLhVj68nBBcn6xf5kSlPm8/bz/vmFg0guLx2cxLRJE1PpLVajd3hOkn63PgFp2MSs36rdzt2j1S23rQ9eGjqtjt6aO0g7Dx5YH7g0dKrdzh1k9m6mg4OXJs4i7xITpBBErK9c7hAHy8kEsV9IJoj9ErKj4UG92EcgSLFfPEGK/bIJUuwXTJBiv1SCFPtFEqTYL6+5QbQfVpTMvvBJEDcI4gxBnCGIMwRxhiDOEMQZgjhDEGcI4gxBnCGIMwRxhiDOEMQZH0E6usPnIScUpKM7YV6tzvAuQU4mSNwb3Anz2nj67qJknfCJYag5iE42dgebYRExl7cECfUGSeX1QjFmQbrvr0vSn3ymrjUF0XH72eBqWEY7De/XE2Xdf8lBx62k9+o5oL3RtZj0zXKPKesaRCfVj6ml74x/qR6MqmcI//0ra+sWJB2/i2pX1ZMj44NfryDBO4I4QxBnCOIMQZwhiDMEcYYgzhDEmeNf0erRCv9ntqMGvjBs5gTvrBckBCGIa9ZXrHCHEMQ16ytWuEMAAAAAAECoyx/KQ1gHA1R4bgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintInvoice);
export default __webpack_public_path__ + "static/media/PrintInvoice.a8136f7cb7dbbe732a630b351d014b87.svg";
export { ForwardRef as ReactComponent };